import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const VitalRecordsFreetype = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [vitalId, setVitalId] = useState(null)
  const [patientVital, setPatientVital] = useState(null)
  const [tempVitalHtml, setTempVitalHtml] = useState('')

  const vitalFields = [
    { name: 'BloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
    { name: 'HeartRate', label: 'Heart Rate', unit: 'bpm' },
    { name: 'RespiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
    { name: 'Temperature', label: 'Temperature', unit: '°F' },
    { name: 'SpO2', label: 'SpO2', unit: '%' },
    { name: 'InhaledO2', label: 'Inhaled O2', unit: '%' },
    { name: 'HeartCirc', label: 'Heart Circ', unit: 'in' },
    { name: 'Height', label: 'Height', unit: 'ft/in' },
    { name: 'Weight', label: 'Weight', unit: 'lbs/oz' },
  ]

  useEffect(() => {
    const id =
      patientDBdata?.currentNote?.data?.metadata?.vitalId ?? null
    setVitalId(id ? Number(id) : null)
  }, [patientDBdata, patientID])

  useEffect(() => {
    if (!vitalId) {
      setPatientVital(null)
      return
    }

    const found =
      patientDBdata?.patientVitals?.find(
        (item) => item.ID === vitalId
      ) || null

    setPatientVital(found)
  }, [vitalId, patientDBdata])

  useEffect(() => {
    if (!patientVital) return

    const generatedHtml = `
      <div>
        <div style="margin-bottom:8px;">
          <strong>Date:</strong> ${patientVital.Date || '-'}
        </div>

        <div style="margin-top:8px;">
          ${vitalFields
            .map(
              (field) => `
            <div style="margin-bottom:6px;">
              <strong>${field.label} (${field.unit}):</strong>
              ${patientVital[field.name] || '-'}
            </div>
          `
            )
            .join('')}
        </div>
      </div>
    `

    const savedFreeType =
      patientDBdata?.currentNote?.data?.freeTypesEverything
        ?.vitalsFreetype

    setTempVitalHtml(savedFreeType || generatedHtml)
  }, [patientVital, patientDBdata])

  useEffect(() => {
  if (!patientVital) return

  const generatedHtml = `
    <div>
      <div style="margin-bottom:8px;">
        <strong>Date:</strong> ${patientVital.Date || '-'}
      </div>

      <div style="margin-top:8px;">
        ${vitalFields
          .map(
            (field) => `
          <div style="margin-bottom:6px;">
            <strong>${field.label} (${field.unit}):</strong>
            ${patientVital[field.name] || '-'}
          </div>
        `
          )
          .join('')}
      </div>
    </div>
  `

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything
      ?.vitalsFreetype

  const initialHtml = savedFreeType || generatedHtml
  setTempVitalHtml(initialHtml)

  if (!savedFreeType) {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            vitalsFreetype: initialHtml,
          },
        },
      },
    }))
  }
}, [patientVital])


  const handleBlur = () => {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            vitalsFreetype: tempVitalHtml,
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              vitalsFreetype: tempVitalHtml,
            },
          }),
        }
      }),
    }))
  }

  if (!vitalId) return null

  return (
    <div className="d-flex">
      <div style={{ width: '30%' }}>Vitals</div>

      <div className="w-100">
        <Editor
          value={tempVitalHtml}
          onChange={(e) => setTempVitalHtml(e.target.value)}
          onBlur={handleBlur}
          containerProps={{
            style: {
              width: '100%',
              background: '#2D2D2D',
              color: 'white',
              border: 0,
            },
          }}
        >
          <Toolbar hidden />
        </Editor>
      </div>
    </div>
  )
}

export default VitalRecordsFreetype
